import { TextFieldProps } from '@blueshift-ui/inputs';
import TextField from '@blueshift-ui/inputs/dist/components/text-field';
import { Control, Controller, ControllerProps } from 'react-hook-form';

type ControlledTextFieldProps = {
  control?: Control<any>;
  controllerProps?: Partial<ControllerProps>;
} & TextFieldProps;

function ControlledTextField({
  control,
  controllerProps,
  ...fieldProps
}: ControlledTextFieldProps) {
  return (
    <Controller
      {...controllerProps}
      control={control}
      name={fieldProps.name}
      render={({ field: { ref, ...field } }) => {
        return (
          <TextField fullWidth InputLabelProps={{ shrink: true }} {...field} {...fieldProps} />
        );
      }}
    />
  );
}

export default ControlledTextField;
